import { Amplify } from 'aws-amplify'
import { GatsbyBrowser } from 'gatsby'
import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import env from '../env'
import store from '../redux/store'
import theme from '../styles/theme'
import AuthProvider from './AuthContext'
import { ChildProvider } from './ChildContext'
import QueryClientProvider from './QueryClientProvider'

Amplify.configure({
  Auth: {
    identityPoolId: env.cognitoIdPoolId,
    region: 'eu-west-1',
    identityPoolRegion: 'eu-west-1',
    userPoolId: env.cognitoPoolId,
    userPoolWebClientId: env.cognitoClientId,
  },
  Analytics: {
    disabled: false,
    AWSPinpoint: {
      appId: env.pinpointProjectId,
      region: 'eu-west-1',
    },
  },
})

const Providers: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <ReduxProvider store={store}>
        <QueryClientProvider>
          <AuthProvider>
            <ChildProvider>{element}</ChildProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ReduxProvider>
    </ThemeProvider>
  )
}

export default Providers
